import React from 'react';
import { Form, Row, Col, Checkbox, Skeleton } from 'antd';

import { usergroupUseQuery } from '../../hooks';
import { Localize } from "components/service";


const columns = {
    span: 24,
    xs: 24,
    lg: 8
};

const panels = [
    { panel: 'crm', label: 'FORMS.Input_Label_CrmRights' },
    { panel: 'sub', label: 'FORMS.Input_Label_SubRights' },
    { panel: 'app', label: 'FORMS.Input_Label_AppRights' },
];

const UserGroupPermissionCheckboxFormItem = ({ disabled = false }) => {

    const { permissions, loading } = usergroupUseQuery.getPermissions(true);

    return (
        <>
            { loading && <Skeleton active={ true } paragraph={ { rows: 10 } } /> }

            { !loading &&

                <Form.Item name="permission_id">
                    <Checkbox.Group >
                        <Row>

                            { panels.map(({ panel, label }) => <Col { ...columns } key={ panel }>
                                <span className="label-text"><Localize>{ label }</Localize> </span>
                                <Row>
                                    { permissions.data.map(permission => {

                                        if (permission.panel === panel)
                                        {

                                            return (

                                                <Col className="my-1" key={ `col-permission-${ permission.id }` } span={ 24 }>

                                                    <Checkbox className='checkbox-outline' value={ parseInt(permission.id) } disabled={ disabled } >
                                                        { permission.label }
                                                    </Checkbox>

                                                </Col>

                                            );
                                        }

                                        return false;

                                    }) }
                                </Row>
                            </Col>) }

                        </Row>
                    </Checkbox.Group>
                </Form.Item>
            }
        </>
    );
};

export default UserGroupPermissionCheckboxFormItem;
